import { z } from 'zod';
/**
 * App Version Response Schema
 * GET /api/v2/version
 */ export const AppVersionResponseSchema = z.object({
    backendVersion: z.string(),
    backendCommit: z.string().optional()
});

//# sourceMappingURL=app-version.schema.js.map